var _path, _mask, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGosiwon = function SvgGosiwon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 50 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M16 8v29h18V8z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "gosiwon_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 30.43a.43.43 0 0 1 .43-.43h4.14a.43.43 0 0 1 .43.43v6.141a.43.43 0 0 1-.429.429H22.93a.43.43 0 0 1-.429-.429z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.5 30.43c0-.79.64-1.43 1.43-1.43h4.14c.79 0 1.43.64 1.43 1.43l-2 .57h-3zm6 6.57h-5zm-4.571 0c-.79 0-1.429-.64-1.429-1.429V30.43c0-.79.64-1.43 1.43-1.43l.57 2v6zm4.141-8c.79 0 1.43.64 1.43 1.43v5.141c0 .79-.64 1.429-1.429 1.429H26.5v-6z",
    mask: "url(#gosiwon_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M20.5 11.5h1M24.5 11.5h1M28.5 11.5h1M20.5 14.5h1M24.5 14.5h1M28.5 14.5h1M20.5 17.5h1M24.5 17.5h1M28.5 17.5h1M20.5 20.5h1M24.5 20.5h1M28.5 20.5h1M20.5 23.5h1M24.5 23.5h1M28.5 23.5h1M20.5 26.5h1M24.5 26.5h1M28.5 26.5h1"
  })));
};
export default SvgGosiwon;